<template>
  <div class="mobile-container">
    <div class="bk-img"></div>
    <userHeader custom-active="1" @platform="updatePlatform" :disablePltBtn="false"></userHeader>
    <div class="list-container">
      <div class="tools">
        <div @click="handleFilter">
          <span>{{ FilterList[Filter].name }}</span>
          <i class="el-icon-arrow-down"></i>
        </div>
        <div @click="Sorted">
          <span>{{ sortList[sort].name }}</span>
          <i class="el-icon-arrow-down"></i>
        </div>
      </div>
      <div class="list-wrapper">
        <div class="item" v-for="(item, index) in data" :key="'item_' + index" @click="toDetail(item)">
          <div class="item-thumbnail">
            <el-image :src="item.Url" class="img" lazy fit="cover" ></el-image>
          </div>
          <div class="item-info">
            <h4>
              <span class="bold">{{ item.Title }}</span>
              <span class="gray">{{$t("lang.BoundValue")}}</span>
            </h4>
            <p class="row">
              <span>{{
              item.owner_name
              }}</span>
              <span class="bold">
                <img v-if="chain == 'ETH'"  :src="require('@/assets/img/nft.svg')" style="max-width: 16px;max-height: 16px;width: auto;height: auto;"/>
                <img v-else-if="chain == 'CFX'" :src="require('@/assets/img/conflux_logo_only.png')" style="max-width: 16px;max-height: 16px;width: auto;height: auto;"/>

                {{  item.nft_amount || 0 }}</span>
            </p>
            <!-- 投票占比 -->
            <div class="progress-container">
              <p>
                <span>{{ item.l_count }}</span>
                <span class="defuse-count">{{ item.r_count }}</span>
              </p>
              <div class="progress">
                <span class="progressing" v-bind:style="'width:' + item.Rate * 100 + '%'">
                </span>
              </div>
            </div>
            <!-- 是否关闭 -->
            <div class="status">
              <span :class="{ closed: Timestatus(item.start_time) === 'Closed' }">{{ Timestatus(item.start_time) }}</span>
            </div>
          </div>
        </div>
        <div class="nodata" v-if="data == null || data.length == 0">
          <img :src="require('@/assets/img/nodata_opting.png')" class="img" />
        </div>
      </div>
    </div>
    <Footer></Footer>
    <select-popover @close="handleClose" @change="handleChange" :show="visible" :List="isFilter ? FilterList : sortList"
      :active="isFilter ? Filter : sort" :size="isFilter ? '200px' : '280px'" :name="true"></select-popover>
  </div>
</template>
<script>
import Header from "@/components/mobile/header";
import userHeader from "@/components/mobile/userHeader";
import Footer from "@/components/footer.vue";
import request from "../../services/request";
import { BASE_V_API, countDownTime } from "@/config.js"
import ad from "../../utils/web3Helper.js";
import moment from "moment";
import selectPopover from "@/components/mobile/select-popover.vue";
import { mapState } from "vuex";
import EventBus from '@/utils/EventBus'
export default {
  name: "pickMarket-m",
  data() {
    return {
      chain: "",
      Filter: 0, //1: 按价格排序 2：总参与人数 3：阵营差值 4：我收藏的(key 需要传入当前地址) 5；即将结束的
      FilterList: [
        // { name: this.$t("lang.AllOption"), value: 1 },
        // { name: this.$t("lang.Active"), value: 2 },
        // { name: this.$t("lang.Closed"), value: 3 },
        { name: this.$t("lang.Ongoing"), value: 1 }, 
        { name: this.$t("lang.Ended"), value: 2 },
      ],
      sort: 1,
      sortList: [
        { name: this.$t("lang.NumberParticipants") + ':' + this.$t("lang.LowToHigh"), value: 1 },
        { name: this.$t("lang.NumberParticipants") + ':' + this.$t("lang.HighToLow"), value: 2 },
        { name: this.$t("lang.EndTime") + ':' + this.$t("lang.LowToHigh"), value: 3 },
        { name: this.$t("lang.EndTime") + ':' + this.$t("lang.HighToLow"), value: 4 },
        { name: this.$t("lang.totalAmount") + ':' + this.$t("lang.LowToHigh"), value: 5 },
        { name: this.$t("lang.totalAmount") + ':' + this.$t("lang.HighToLow"), value: 6 },
        // { name: this.$t("lang.Recently"), value: 7 },
      ],
      data: [],
      activeName: "1",
      base: "",
      loading: false,
      visible: false,
      isFilter: true,
    };
  },
  computed: {
    ...mapState(["address"]),
  },
  components: {
    Header,
    Footer,
    selectPopover,
    userHeader
  },
  created() {
    this.loadData();
    EventBus.$on('share', value => {
      // 将 A 组件传递过来的数据保存到 B 组件
            console.log("value123",value)
           if(value){
            this.loadData();
            this. FilterList=[
                { name: this.$t("lang.Ongoing"), value: 1 }, 
                { name: this.$t("lang.Ended"), value: 2 },
            ];
            this.sortList= [
                { name: this.$t("lang.NumberParticipants") + ':' + this.$t("lang.LowToHigh"), value: 1 },
                { name: this.$t("lang.NumberParticipants") + ':' + this.$t("lang.HighToLow"), value: 2 },
                { name: this.$t("lang.EndTime") + ':' + this.$t("lang.LowToHigh"), value: 3 },
                { name: this.$t("lang.EndTime") + ':' + this.$t("lang.HighToLow"), value: 4 },
                { name: this.$t("lang.totalAmount") + ':' + this.$t("lang.LowToHigh"), value: 5 },
                { name: this.$t("lang.totalAmount") + ':' + this.$t("lang.HighToLow"), value: 6 },
              ];
           }

        })
  },
  methods: {
    onCarouselChange(index) {
      const bkImg = document.querySelector(".bk-img");
      if (!bkImg) return;
      const imageUrl = this.data[index].Url;
      // Directly assign (no preload)
      bkImg.style.backgroundImage = `url(${imageUrl})`;
    },
    updatePlatform() {
      this.loadData();
    },
    Timestatus(startTime) {
      let endTime = startTime *1000 + countDownTime * 1000; //游戏结束时间
      let time = endTime - new Date().getTime(); //获取当前时间
      // let time=3540000;
      let status;
      if (time < 0) {
        status = this.$t("lang.Closed");
      } else {
        let mintue = parseInt((time % (1000 * 60 * 60)) / (1000 * 60));
        let hours = parseInt((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        if (mintue < 1) {
          let second = Math.floor(time / 1000);
          status = second + " second left";
        } else {
          status = (hours > 0 ? hours + 'hours' : '') + ' ' + mintue + (mintue > 1 ? " mintues " : " mintue ") + "left";
        }
      }
      return status;
    },
    handleFilter() {
      this.visible = true;
      this.isFilter = true;
    },
    Sorted() {
      this.visible = true;
      this.isFilter = false;
    },
    handleClose() {
      this.visible = false;
    },
    showDrawer() {
      if (this.data.length == 0) return;
      this.visible = true;
    },
    handleChange(i) {
      if (this.isFilter) {
        this.Filter = i;
      } else {
        this.sort = i;
      }
      this.visible = false;
      this.loadData();
    },
    toDetail(item) {
      this.$router.push({ name: "nftDetail-m", query: { tokenID: item.asset_id,id:item.id } });
    },
    loadData() {
      this.base = BASE_V_API;
      // this.showLoading()
      const params = {
        // key: this.address || "",
        page: 1,
        page_size: 10000,  
        status: this.Filter + 1,
        sort: this.sort + 1,
        typa:2
      };
      request.getOpting(params).then((response) => {
        if (response.code == 200) {
          this.loading = false;
          this.data = response.data;
          this.data.forEach((item, index) => {
            // this.data[index].Amount = ad.fromWei(this.data[index].Amount);
            var ac = parseInt(item.l_count);
            var dc = parseInt(item.r_count);
            if (ac == 0 && dc == 0) {
              this.data[index].Rate = 0.5;
            } else {
              this.data[index].Rate = ac / (ac + dc);
            }
          });
        } else {
          this.loading = false;
          this.$message.error(response.message);
        }
      });
    },
    showLoading() {
      this.loading = this.$loading({
        lock: true,
        text: this.$t("lang.please"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bk-img {
  background-image: url("../../assets/img/home/bg-image-1_1bg-image-1.avif");
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 120px;
  padding-bottom: 350px;
  width: 100vw;
  height: 600px;
  position: absolute;
  top: -40px;
  left: 0;
  z-index: -100;
  filter: blur(40px);
  transition: background-image 0.5s ease-in-out;

}
.bk-img::after {
  filter: blur(40px);
  content: "";
  position: absolute;
  top: 300px;
  left: 0;
  width: 100%;
  height: 50%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 100%);
}
/* Container styling for the entire list area */
.list-container {
  min-height: calc(100vh - 260px);
  background-color: transparent; /* Subtle background, can be changed or removed */

  /* Banner Carousel */
  .banner {
    width: 90%;
    margin: 0 auto 20px; /* space under carousel */
    position: relative;
    background: transparent;

    /* Optional: subtle shadow or border for the carousel container */
    /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
       border-radius: 12px;
       overflow: hidden; */

    el-carousel {
      background: transparent;
      .el-carousel__arrow {
        /* Make the arrows a bit sleeker */
        opacity: 0.7;
        &:hover {
          opacity: 1;
        }
      }
      .el-carousel__indicators--outside {
        bottom: 5px; /* Move indicators up a bit */
      }
      .el-carousel__indicators button {
        background-color: #ddd;
        &.is-active {
          background-color: #7d6fff; /* brand accent color */
        }
      }

      el-carousel-item {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative; /* So absolutely-positioned children remain inside */
      }
    }

    /* Each slide container */
    .banner-item {
      position: relative;
      width: 100%;
      height: 400px; /* or your chosen banner height */
      overflow: hidden;
      border-radius: 12px;

      /* Hover scaling for the image (desktop / tablet) */
      &:hover {
        .background-img {
          transform: scale(1.03);
        }
      }

      /* Main image container */
      .img-containerBig {
        position: absolute;
        inset: 0;
        z-index: 1;
        overflow: hidden;
        border-radius: 12px;
        .background-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }
      }

      /* The text overlay, placed around 60% from the top, centered horizontally */
      .banner_detail {
        position: absolute;
        top: 80%;           /* 60% from the top of the banner */
        left: 50%;
        transform: translate(-50%, -50%);  /* Center horizontally, shift up to meet 60% line */
        z-index: 2;         /* Ensure it's above the image */
        width: 80%;         /* or 60–80% for narrower text box */
        padding: 6px 8px;

        /* If you want a frosted glass effect: */
        background-color: rgba(255, 255, 255, 0.4);
        backdrop-filter: blur(8px);
        border-radius: 8px;

        /* Smaller, modern font sizes */
        font-size: 14px;   /* base font size for the overlay text */
        color: #333;
        text-align: center; /* center the text if you like */

        .banner-votes {
          display: flex;
          align-items: center;
          justify-content: space-between; /* space out left/mid/right */
          margin-top: 10px; /* add some spacing above */

          .vote-left,
          .vote-right {
            display: inline-flex;
            align-items: center;
            gap: 6px; /* space between icon and text */

            .vote-icon {
              width: 30px;
              height: 30px;
            }
            span {
              font-size: 18px;
              font-weight: 600;
              color: #333;
            }
          }

          .vote-mid {
            /* Middle content. You can center text or style differently */
            p {
              font-size: 13px;
              color: #444;
              margin: 0;
              padding: 0;
            }
          }
        }
        .banner-description {
          margin-top: 4px;
          font-size: 13px;
          color: #444;
          line-height: 1.4em;
          display: -webkit-box;
          -webkit-line-clamp: 3;        /* Show at most 3 lines */
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        h3 {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 6px;
        }

        /* Example small spans for owner / price */
        span {
          display: inline-flex;
          align-items: center;
          font-size: 13px;
          font-weight: 500;
          margin: 0 5px;
          color: #444;

          img.eth_icon {
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }
        }


        .banner-description {
          margin-top: 4px;
          font-size: 14px;
          color: #444;
          line-height: 1.4em;

          /* Optional multiline clamp */
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        /* Progress container (icons + bar) */
        .progress-container {
          display: flex;
          align-items: center;
          justify-content: center;

          .icon-wraper {
            position: relative;
            display: flex;
            align-items: center;
            margin: 0px;

            .progress-icon {
              width: 24px;
              height: 24px;
              transition: opacity 0.2s;
            }
            //.hover-count {
            //  position: absolute;
            //  top: 50%;
            //  left: 50%;
            //  transform: translate(-50%, -50%);
            //  font-size: 14px;
            //  color: #fff;
            //}
          }
          .progress {
            position: relative;
            width: 60%;
            height: 8px;
            background: #e0e0e0;
            border-radius: 4px;

            .progressing {
              display: block;
              height: 8px;
              border-radius: 4px;
              left: 0;
              background: #7d6fff;
              transition: width 0.3s ease;
            }
          }
          //.progress {
          //  flex: 1;
          //  height: 8px;
          //  margin: 0;
          //  border-radius: 4px;
          //  background-color: #e6e6e6;
          //  position: relative;
          //
          //  .progressing {
          //    display: block;
          //    height: 8px;
          //    border-radius: 4px;
          //    background-color: #7d6fff; /* brand accent color */
          //    transition: width 0.3s ease;
          //    left: 0px; /* Ensure it starts from the left */
          //    position: absolute; /* Make sure it is positioned absolutely */
          //  }
          //}
        }
      }
    }
  }

  /* Filter / Sort Tools */
  .tools {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 10px 15px;


    div {
      background-color: #fafafa;
      width: 48%;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 6px 12px;
      border-radius: 8px;
      border: 1px solid #ccc;
      cursor: pointer;
      transition: all 0.2s ease;

      span {
        color: #666;
      }
      i {
        font-size: 14px;
        color: #aaa;
      }

      &:hover {
        border-color: #7d6fff;
        span {
          color: #7d6fff;
        }
        i {
          color: #7d6fff;
        }
      }
    }
  }

  /* Main content list */
  .list-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 5px 20px;

    /* Each item card */
    .item {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 2px 0 rgba(0, 0, 0, 0.1);
      background-color: #FFFFFF;
      border-radius: 10px;
      width: 48%;
      padding: 6px;
      margin: 5px 0px;

      .item-thumbnail {
        position: relative;
        width: 100%;
        height: 240px;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);

        .el-image {
          width: 100%;
          height: 100%;
          border-radius: 8px;
          object-fit: cover;
          transition: transform 0.2s ease;
          &:hover {
            transform: scale(1.03);
          }
        }
      }

      .item-info {
        font-size: 13px;
        color: #666;

        h4 {
          display: flex;
          align-items: center;
          justify-content: space-between;
          line-height: 20px;
          margin-bottom: 4px;

          .bold {
            max-width: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: 600;
            color: #333;
          }
          .gray {
            font-size: 12px;
            font-weight: 400;
            color: #999;
            text-align: right;
            max-width: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 6px;

          span {
            &.bold {
              font-weight: 600;
              color: #333;
              display: inline-flex;
              align-items: center;

              img {
                width: 18px;
                margin-right: 4px;
              }
            }
          }
        }

        /* Progress bar for votes */
        .progress-container {
          margin-bottom: 6px;

          p {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 4px;

            span {
              font-size: 14px;
              &.defuse-count {
                color: #999;
              }
            }
          }
          .progress {
            position: relative;
            width: 100%;
            height: 8px;
            background: #e0e0e0;
            border-radius: 4px;

            .progressing {
              display: block;
              height: 8px;
              border-radius: 4px;
              left: 0;
              background: #7d6fff;
              transition: width 0.3s ease;
            }
          }
        }

        /* Status text (Ongoing/Closed) */
        .status {
          span {
            font-weight: 600;
            font-size: 13px;
            color: #666;
            &.closed {
              color: #333;
            }
          }
        }
      }
    }

    /* No data placeholder */
    .nodata {
      width: 100%;
      margin-top: 40px;
      text-align: center;
      img {
        width: 160px;
        opacity: 0.8;
      }
    }
  }
}

/* Overwrite loading spinner if needed */
.el-loading-spinner i {
  color: #dadce6;
  font-size: 30px;
}
.el-loading-spinner .el-loading-text {
  color: #dadce6;
  margin-top: 5px;
}
</style>

<style>
.el-loading-spinner i {
  color: #dadce6;
  font-size: 30px;
}

.el-loading-spinner .el-loading-text {
  color: #dadce6;
  margin-top: 5px;
}
</style>